{
  "endTime": "Ora di fine",
  "startTime": "Ora di inizio",
  "time": "Ora"
}
